import {ErrorHandler, inject, Injectable} from '@angular/core';
import {AdobeTrackingService} from '@datev/ngx-adobe-tracking';
import {DcalError} from '@datev/dcal';


@Injectable()
export class AppErrorHandler implements ErrorHandler {

  private readonly adobeTrackingService = inject(AdobeTrackingService);

  handleError(error: any): void { // NOSONAR

    if (error?.rejection instanceof DcalError) {
      this.adobeTrackingService.publishClickEvent('Error:DcalError:GlobalError');
    }
    throw error; // solange noch keine Fehlerbehandlung umgesetzt wurde
  }
}
